import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { UserContextSelectors } from "../redux/selectors";
import { useSelector } from "react-redux";
import { UserIconPostLoginVIP } from "./SVG/UserIconPostLoginVIP";
import { UserIconPostLoginDefault } from "./SVG/UserIconPostLoginDefault";
import classNames from "classnames";
import { ThemeUtils } from "../utils";
import profileIconNameMrGreen from "../styles/images/mrg-new-avatar.png";
import profileIconPreLoginNameMrGreen from "../styles/images/mrg-prelogin.png";
import { BrandUtils } from "../utils/brandUtils";

const ProfileDetails = ({ onProfilePicClick, trackingInfo }) => {
  const userName = useSelector(UserContextSelectors.username);
  const name = useSelector(UserContextSelectors.displayName);
  const displayName = BrandUtils.isPokerClient() ? userName : name;
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);

  const trackingInfoLocal = useMemo(() => {
    return trackingInfo
      ? Object.assign({}, trackingInfo, { dataLabel: "Avatar" })
      : Object.assign({}, trackingInfo, {
          dataCategory: "default",
          dataAction: "click",
          dataLabel: "Avatar"
        });
  }, [trackingInfo]);

  const isVip = useSelector(UserContextSelectors.isVip);
  const showIndicateVIP = isVip && ThemeUtils.isDefaultTheme();

  const ProfileIconComponent = useMemo(
    () => (showIndicateVIP ? UserIconPostLoginVIP : UserIconPostLoginDefault),
    [showIndicateVIP]
  );

  const profileIconClasses = useMemo(
    () =>
      classNames(
        { "icon-vip": showIndicateVIP },
        { "post-login": isAuthenticated }
      ),
    [showIndicateVIP, isAuthenticated]
  );

  const handleCTA = () => {
    document.body.classList.add("no-scroll");
    onProfilePicClick();
    return true;
  };

  return (
    <div className="aCprofileBox">
      <div className="aCprofileDetails">
        <a
          className="aCprofilePic do-not-close-account-drawer"
          onClick={handleCTA}
          data-category={trackingInfoLocal.dataCategory}
          data-action={trackingInfoLocal.dataAction}
          data-label={trackingInfoLocal.dataLabel}
          data-value=""
        >
          {!ThemeUtils.isMrGreenTheme() && (
            <ProfileIconComponent
              className={classNames({ "icon-vip": showIndicateVIP })}
            />
          )}
          {ThemeUtils.isMrGreenTheme() && isAuthenticated && (
            <img
              src={profileIconNameMrGreen}
              className={profileIconClasses}
              alt="profile-details"
            />
          )}
          {ThemeUtils.isMrGreenTheme() && !isAuthenticated && (
            <img
              src={profileIconPreLoginNameMrGreen}
              className={profileIconClasses}
              alt="profile-details"
            />
          )}
        </a>
      </div>
      <div className="aCuserName">{displayName}</div>
    </div>
  );
};

ProfileDetails.propTypes = {
  onProfilePicClick: PropTypes.func,
  trackingInfo: PropTypes.object
};

export default React.memo(ProfileDetails);
